import React from 'react';

import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import SmsConfirmation from 'apps/auth/components/utils/SmsConfirmation';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';

const PaymentSmsConfirmModal = (props) => {
    return (
        <ModalComponent linkTo={AUTH_SEND_MAIN_LINK} isIconClose>
            <SmsConfirmation
                smsConfirmation={props.smsConfirmation}
                confirmAction={'/payment/confirm.action'}
                redirectUrl={props.redirectUrl}
                smsLength={6}
                headerText={props.customTitle}
                headerGrayText={props.enterSmsTitle}
                declineResendSms
            />
        </ModalComponent>
    );
};
export default PaymentSmsConfirmModal;
